import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/manae_strategies',
  component: Layout,
  redirect: '/manae_strategies/index',
  name: 'ManageStrategies',
  meta: {
    title: '策略管理',
    i18n: 'route.tabbar',
    icon: 'i-ic:round-tab',
  },
  children: [
    {
      path: 'index',
      name: 'ManageStrategiesIndex',
      component: () => import('@/views/manae_strategies/index.vue'),
      meta: {
        title: '策略管理',
        menu: false,
        breadcrumb: false,
        activeMenu: '/manae_strategies',
      },
    },
  ],
}

export default routes
